<div class="fixed top-3 right-3 z-50 sm:top-4 sm:right-4">
    <button type="button"
        class="flex h-9 items-center gap-2 rounded-lg border border-slate-200 bg-white px-2.5 text-sm font-medium text-[#00165A] shadow-sm hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#00165A] sm:px-3"
        aria-haspopup="listbox" aria-controls="language-menu" [attr.aria-expanded]="open()"
        [attr.aria-label]="'Language: ' + currentLabel()" (click)="popover.toggle($event)">
        <i class="pi pi-globe text-sm" aria-hidden="true"></i>
        <span class="hidden sm:inline">{{ currentLabel() }}</span>
        <i class="pi pi-chevron-down text-[10px] text-slate-400 transition-transform" [class.rotate-180]="open()"
            aria-hidden="true"></i>
    </button>

    <p-popover #popover appendTo="body" styleClass="language-menu-panel" ariaLabelledBy="language-menu" (onShow)="open.set(true)"
        (onHide)="open.set(false)">
        <ul id="language-menu" role="listbox" aria-label="Language" class="m-0 flex min-w-40 list-none flex-col p-0">
            @for (lang of languages; track lang.code) {
            <li>
                <button type="button" role="option"
                    class="flex w-full items-center justify-between gap-6 rounded-md px-3 py-2 text-left text-sm text-[#00165A] hover:bg-slate-50"
                    [class.bg-slate-100]="lang.code === i18n.language()" [class.font-semibold]="lang.code === i18n.language()"
                    [attr.aria-selected]="lang.code === i18n.language()" (click)="select(lang.code, popover)">
                    <span>{{ lang.label }}</span>
                    @if (lang.code === i18n.language()) {
                    <i class="pi pi-check text-xs" aria-hidden="true"></i>
                    }
                </button>
            </li>
            }
        </ul>
    </p-popover>
</div>